module.exports = __webpack_public_path__ + "img/tree-edit.91fa0c43.svg";